module.exports = __webpack_public_path__ + "img/zero-balance-income.4e62ff7f.svg";